import React, { useState } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";

import appointmentService from "../../services/appointmentService";

const AppointmentCancelModal = (props) => {
  const { appointmentId, type, refreshAppointments } = props;

  const [modal, setModal] = useState(false);

  const toggle = () => setModal(!modal);

  const cancelAppt = () => {
    const appt = { appointmentId: appointmentId, userId: "" };
    appointmentService.attorneyCancelAppointment(appt).then(() => {
      refreshAppointments();
      toggle();
    });
  };

  const completeAppt = () => {
    const appt = { appointmentId: appointmentId, userId: "" };
    appointmentService.attorneyCompleteAppointment(appt).then(() => {
      refreshAppointments();
      toggle();
    });
  };

  return (
    <div className="mt-auto">
      <Button onClick={toggle} style={{ width: "100%" }}>
        Cancel appointment
      </Button>
      <Modal isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>{type} appointment</ModalHeader>
        <ModalBody>Are you sure you want to {type} the appointment?</ModalBody>
        <ModalFooter>
          {type === "Cancel" && (
            <Button color="danger" onClick={cancelAppt}>
              Cancel appointment
            </Button>
          )}
          {type === "Complete" && (
            <Button color="success" onClick={completeAppt}>
              Complete appointment
            </Button>
          )}{" "}
          <Button color="secondary" onClick={toggle}>
            Close
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default AppointmentCancelModal;
